import apiMiddleware from "../../../api/apiMiddleware";

// list activities with pagination and search
const list = async ({ page = 1, search = "" }) => {
  const response = await apiMiddleware.get(
    `activity-master?page=${page}${search ? `&search=${search}` : ""}`
  );
  return response.data;
};

// create activity
const create = async (activity) => {
  const response = await apiMiddleware.post("activity-master", activity);
  return response.data;
};

// get activity by id
const getById = async (id) => {
  const response = await apiMiddleware.get(`activity-master/${id}`);
  return response.data;
};

// update activity
const update = async ({ id, activity }) => {
  const response = await apiMiddleware.put(`activity-master/${id}`, activity);
  return response.data;
};

// delete activity
const deleteActivity = async (id) => {
  const response = await apiMiddleware.delete(`activity-master/${id}`);
  return response.data;
};

export { list, create, getById, update, deleteActivity };
